<template>
  <v-list>
    <v-list-item
      v-for="invitation in invitations"
      :key="invitation.id"
    >
      <v-list-item-content>
        <v-list-item-title>{{ invitation.email }}</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action v-if="canCancelInvitations">
        <v-btn
          :loading="form.processing && processingInvitation === invitation.id"
          :disabled="form.processing && processingInvitation === invitation.id"
          small
          color="error"
          @click="cancelInvitation(invitation)"
        >
          {{ $t('Remove') }}
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    invitations: {
      type: Array,
      required: true
    },
    canCancelInvitations: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      processingInvitation: null,
      form: this.$inertia.form({})
    }
  },

  methods: {
    async cancelInvitation(invitation) {
      const confirmed = await this.$root.$confirm(
        this.$t(`Remove invitation`),
        this.$t(`Are you sure you want to remove this invitation?`)
      );

      if (confirmed) {
        const url = this.route('team-invitations.destroy', invitation.id);
        this.processingInvitation = invitation.id;

        this.form.delete(url, {
          onFinish: () => {
            this.processingInvitation = null;
          }
        });
      }
    }
  }
}
</script>